import type {
  CreateDrawerRequest,
  CreateDrawerFromCatalogRequest,
  DrawerDetails,
  DrawerListItem,
  ListDrawersResponse,
  UpdateDrawerRequest,
} from '@kreart/shared';
import { api } from '@/lib/api';

export const drawersApi = {
  list: (projectId: string, cabinetId: string) =>
    api.get<ListDrawersResponse>(`/projects/${projectId}/cabinets/${cabinetId}/drawers`),
  get: (projectId: string, cabinetId: string, id: string) =>
    api.get<DrawerDetails>(`/projects/${projectId}/cabinets/${cabinetId}/drawers/${id}`),
  create: (projectId: string, cabinetId: string, body: CreateDrawerRequest) =>
    api.post<DrawerListItem>(`/projects/${projectId}/cabinets/${cabinetId}/drawers`, body),
  createFromCatalog: (projectId: string, cabinetId: string, body: CreateDrawerFromCatalogRequest) =>
    api.post<DrawerListItem>(
      `/projects/${projectId}/cabinets/${cabinetId}/drawers/from-catalog`,
      body,
    ),
  update: (projectId: string, cabinetId: string, id: string, body: UpdateDrawerRequest) =>
    api.patch<DrawerListItem>(`/projects/${projectId}/cabinets/${cabinetId}/drawers/${id}`, body),
  remove: (projectId: string, cabinetId: string, id: string) =>
    api.delete<void>(`/projects/${projectId}/cabinets/${cabinetId}/drawers/${id}`),
};
